import farmRole from 'assets/images/roles/farm/Terms and Conditions.svg';
import WholesalerRole from 'assets/images/roles/wholesaler/Terms and Conditions.svg';
import Header from './header';
import Paragraph from './paragraph';
const Roles = ({app}: IRolesPageProps) => {
  return (
    <div className="px-2 mb-8 pb-8">
      {app === 'farm' ? (
        <img src={farmRole} alt="roles" className="block mx-auto " />
      ) : (
        <img src={WholesalerRole} alt="roles" className="block mx-auto " />
      )}
      <Header title="راهنمای خرید امن:" />
      <Paragraph text="به هیچ‌ وجه مشخصات حساب‌های بانکی خودتان را در اختیار افراد ناشناش قرار ندهید." />
      <Paragraph text="ابتدا از هویت و اصالت کالا و فردی که قرار است با او معامله کنید مطمئن شوید." />
      <Paragraph text="حتما از کسانی خرید کنید که امکان ملاقات حضوری آنها پیش از انجام معامله فراهم است." />
      <Paragraph
        text="در صورت ایجاد مزاحمت برای شما از سمت کاربر و اشخاصی که در سامانه حضور پیدا می‌کنند حتما آن کاربر را گزارش دهید
یا با پشتیبانی سایت تماس بگیرید تا موضوع پیگیری و حل شود."
      />
      <Paragraph text="در صورت امکان، هنگام خرید محصول رسید کتبی معتبر از فرد فروشنده کالا دریافت کنید." />
      <Paragraph
        ParagraphClassName="pb-4"
        text="حتما در اماکن معتبر و امن همچون نزدیک پایگاه‌های پلیس، شعب بانک‌ها و ... قرار ملاقات برای معاملات غیررسمی و
غیرفروشگاهی بگذارید."
      />
      <Header title="توصیه مقام محترم قضایی:" />
      <Paragraph
        text="حسب دستور معاون دادستان و سرپرست محترم دادسرا به منظور جلوگیری از سوء استفاده جاعلین و کلاهبرداران از طریق چک های رمز دار بین بانکی،
توجه شما را به متن ارسالی جلب می نماییم:"
      />
      <Paragraph
        ParagraphClassName="pb-4"
        text="با توجه به اینکه یکی از شگردهای مجرمین و متهمین سابقه دار جهت کسب منابع مادی زود هنگام و سریع خرید و فروش ملک و یا اجناس دیگر
با چک‌های جعلی می‌باشد این افراد سابقه دار با جعل چک‌های بین بانکی رمز دار و تماس تلفنی با شهروندان که جهت فروش اجناس خود در
شبکه‌های اجتماعی یا جراید آگهی فروش منتشر کرده بودند تمایل خود را جهت خرید ملک یا کالا اعلام و غالبا در ایام آخر هفته و ساعات پایانی
روز در محل قرار حاضر شده و با فریب و نیرنگ و معرفی خود بعنوان افراد متشخص و حائز شغل و منزلت اجتماعی اقدام به خرید
می‌نمایند و در قبال آن یک فقره چک بین بانکی رمزدار جعلی ارائه می‌نمایند که تا کنون پرونده‌های متعدد در این خصوص تشکیل شده است."
      />
      <Header title="نکات پیش از معامله:" />
      <Paragraph text="بیعانه ندهید: هرگز پیش از دریافت محصول، هزینه‌ای تحت عنوان بیعانه، شیرینی، رزرو و… پرداخت نکنید." />
      <Paragraph text="ذخیره اطلاعات: اطلاعات فروشنده را حتماً ذخیره کنید تا در صورت نیاز، دسترسی سریع داشته باشید." />
      <Paragraph text="درخواست فاکتور خرید: در مورد برخی محصولات بهتر است از فروشنده بخواهید فاکتور خرید را به همراه داشته باشد." />
      <Paragraph
        ParagraphClassName="pb-4"
        text="پرهیز از مزاحمت: دادن اطلاعات شخصی که نامربوط به معامله است، فقط احتمال مزاحمت را بالا می‌برد."
      />
      <Header title="زنگ خطرهای معامله:" />
      <ul className="list-style-type: disc pb-6 text-gray-6 leading-10">
        <li className="list-style-type: disc">
          قیمت و شرایط ارائه شده بیش از حد عالی به نظر می رسد.
        </li>
        <li className="list-style-type: disc ">
          درخواست بیعانه قبل از دریافت محصول، به هر عنوانی توسط فروشنده پیشنهاد
          شود.
        </li>
        <li className="list-style-type: disc">
          {' '}
          فروشنده اطلاعات شفاف و کاملی درباره محصول ارائه نمی‌کند.
        </li>
        <li className="list-style-type: disc">
          در میانه چت‌کردن در چت سامانه، مخاطب درخواست می‌کند که مکالمه در سایر
          پیام‌رسان‌ها مانند تلگرام و واتس‌اپ و … ادامه پیدا کند.
        </li>
        <li className="list-style-type: disc">
          طرف مقابل بدون دلیل منطقی درخواست معامله حضوری را رد کند.
        </li>
        <li className="list-style-type: disc">
          طرف مقابل بدون دلیل منطقی اطلاعات شخصی یا حساب بانکی شما را می‌پرسد.
        </li>
        <li className="list-style-type: disc">
          خریدار بخواهد بدون دیدن محصول، آن را با قیمت عالی بخرد.
        </li>
      </ul>
      <Header title="حساب کاربری:" />
      <Paragraph text="نقش مزرعه در معاملات:" />
      <Paragraph text="سامانه مزرعه هیچ سودی در قبال خرید و فروش محصولات شما نمی‌برد به همین خاطر مسولیتی در قبالشان نخواهد داشت." />
      <Paragraph text="پیگیری موارد گزارش شده و انتقال به مقام‌های قضایی بابت پیگیری." />
      <Paragraph
        ParagraphClassName="pb-4"
        text="فرشگاه مزرعه هیچ گونه نقشی در قیمت‌گذاری محصولاتی که ارایه می شود ندارد و مستقیما از سمت فروشندگان و ارایه دهندگان
محصول این امر انجام می‌گیرد."
      />
      <Header title="آگهی‌های من:" />
      <Paragraph
        ParagraphClassName="pb-4"
        text="در این بخش می‌توانید تمامی آگهی‌هایی که در فروشگاه مزرعه ثبت کردید را مشاهده کنید و اگر نیاز به تغییرات و حذف داشته
باشید از این بخش اقدام کنید"
      />
      <Header title="نظرات و گزارشات:" />
      <Paragraph
        ParagraphClassName="pb-4"
        text="در این بخش جواب نظراتی که در رابطه با خریدهای قبلی داشتید را می‌توانید مشاهده کنید."
      />
      <Header title="آگهی‌های نشان شده:" />
      <Paragraph
        ParagraphClassName="pb-4"
        text="اگر کارت آگهی را مشاهده کردید و خواستید بعدا سریعا به آن دسترسی داشته باشید می توانید با استفاده از علامت تعیین شده در
کارت‌های آگهی آن را نشانه گذاری کنید و در بخش آگهی‌های نشان شده مشاهده کنید."
      />
      <Header title="خدمات کلی:" />
      <Paragraph
        text="گریدبندی: در سامانه مزرعه شما می‌توانید محصولات خود را بر اساس کیفیت با استفاده از یک استاندارد مشخص رتبه‌بندی و
ارئه کنید و مشتریان هم به طور مشخص از کم و کیف محصول شما آگاه شوند."
      />
      <Paragraph
        text="اعتبارسنجی: علاوه بر گریدبندی، این امکان در سامانه مزرعه مزرعه فراهم هست تا صحت گرید اعلام شده محصول
توسط کارشناسان دیگری که توسط شما برگزیده می‌شوند تایید شود."
      />
      <Paragraph
        text="ثبت آگهی: در این بخش شما می‌توانید نسبت به محصولاتی که تولید کردید یا نیاز به خرید آن دارید با انتخاب دسته‌بندی مناسب
آگهی خرید یا فروش ثبت کنید تا اشخاصی که مخاطب آگهی هستند با شما ارتباط برقرار کنند."
      />
      <Paragraph
        ParagraphClassName="pb-4"
        text="پیام‌ها: در این صفحه شما می‌توانید تمامی پیام‌هایی که با افراد مختلف داشته‌اید را مشاهده کنید و همین طور اگر شخصی در
رابطه با آگهی محصول شما پرسشی داشته را پاسخ دهید."
      />
      <Header title="سوالات تخصصی:" />
      <Paragraph text="چه مدت زمانی بعد از درخواست ثبت آگهی کارت آگهی من منتشر خواهد شد؟" />
      <Paragraph
        text="بعد از ثبت درخواست شما کارشناسان ما محتوای آگهی شما را برسی خواهند کرد و اگر مغایرتی با قوانین و مقررات سامانه مزرعه
نداشته باشد بین یک تا ده ساعت آینده منتشر خواهد شد."
      />
      <Paragraph text="در چه صورتی آگهی من رد شده اعلام می‌شود؟" />
      <Paragraph
        text="پس از برسی کارشناسان‌ ما در بخش‌های مختلف آگهی اعم از عکس، تیتر، توضیحات و... اگر مغایرتی با قوانین و مقررات
سامانه داشته باشد آگهی شما رد شده اعلام می‌شود و در قسمت آگهی‌های من با عنوان تیتر رد شده مشاهده خواهید کرد."
      />
      <Paragraph text="انتشار هرگونه آگهی که خارج از قلمرو سرزمینی ایران باشد." />
      <Paragraph
        text="انتشار هرگونه آگهی که موضوع و محتوا و تصویر آن شامل چیزی‌ باشد که نگهداری و خرید و فروش آن در قلمرو سرزمینی ایران غیرقانونی
است."
      />
      <Paragraph text="انتشار هرگونه آگهی که موضوع و محتوا و تصویر آن در لیست کالاها و فعالیت‌های ممنوعه قرار دارد." />
      <Paragraph text="انتشار آگهی تکراری" />
      <Paragraph text="انتشار هرگونه آگهی‌ که شامل عباراتی غیرمرتبط با موضوع آگهی باشد." />
      <Paragraph text="انتشار هرگونه آگهی که مضمون آن مستهجن و مبتذل و نامتعارف یا بر خلاف قوانین کشور باشد." />
      <Paragraph
        text="انتشار هرگونه آگهی که شامل توهین‌ و نشر اکاذیب و افترا باشد و محتوای آن منجر به نقض حقوق مادی و معنوی شخص ثالث یا تعرض به
اموال و دارایی او شود."
      />
      <Paragraph text="انتشار هرگونه آگهی که حاوی خبرپراکنی سیاسی و اجتماعی و مذهبی یا عقاید شخصی و دعوت به تظاهرات و کمپین‌ها باشد." />
      <Paragraph text="انتشار هرگونه آگهی در دسته‌بندی نادرست" />
      <Paragraph text="انتشار هرگونه آگهی با عنوان و محتوای نادرست و مبهم و گمراه‌کننده" />
      <Paragraph text="انتشار هرگونه آگهی که مخل آرامش جامعه یا مغایر با ارزش‌های مزرعه باشد." />
      <Paragraph text="انتشار هرگونه آگهی که ناقض حقوق مالکیت فکری مزرعه یا اشخاص ثالث باشد." />
      <Paragraph text="انتشار هرگونه آگهی که موضوع و محتوای آن به تشخیص نهادهای تخصصی موقتاً دارای محدودیت یا ممنوعیت باشد." />
      <Paragraph text="انتشار هرگونه آگهی که منجر به نفرت‌پراکنی یا بی‌احترامی به گروه‌های قومی و مذهبی و جنسیتی شود." />
      <Paragraph text="انتشار هرگونه محتوایی که حقوق زنان، کودکان، سالمندان، مهاجران خارجی یا موارد مشابه را نقض کند." />
      <Paragraph text="آیا بابت انتشار آگهی در سامانه مزرعه باید هزینه‌ای پرداخت کنم؟" />
      <Paragraph
        text="خیر انتشار آگهی در سامانه مزرعه کاملا رایگان است ولی شما می‌توانید از پکیج‌های غیررایگان مختلف برای بهتر دیده شدن
آگهی تان برای فروش بیشتر استفاده کنید."
      />
      <Paragraph text="انتشار آگهی در سامانه مزرعه چه مزیتی برای من دارد؟" />
      <Paragraph
        text="وجه تمایز و برتری ما در این است که با سامانه مزرعه که پلتفرم اختصاصی کشاورزان است ارتباط دوسویه دارد و شما به طور
مستقیم با جامعه تخصصی بزرگی از کشاورزان مرتبط می‌شوید."
      />
    </div>
  );
};

export default Roles;
